import Markdown from "react-markdown";
import translate from "../locales";

export function PrivacyCard({ onClose }) {
  return (
    <main className="app__container">
      <div className="card">
        <div className="progress">
          <button type="button" className="progress__back" onClick={onClose}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="progress__back-icon"
              viewBox="0 0 24 24"
              fill="currentColor"
              aria-label={translate("general.prev_page_aria")}
            >
              <path d="M10 18L4 12L10 6L11.4 7.45L7.85 11H20V13H7.85L11.4 16.55L10 18Z" />
            </svg>
          </button>
          <p className="progress__title">{translate("privacy.title")}</p>
        </div>
        <div className="privacy-card__body">
          <Markdown>{translate("privacy.content_markdown")}</Markdown>
        </div>
      </div>
    </main>
  );
}
